export class Customer {
    customerId: number;
    firstName: string;
    lastName: string;
    address: string;
    city: string;
    email: string;
    phone: string;
    state: string;
    zip: string;
	modifiedBy: string;
	quoteRevisionNumber: number;

    constructor() {
        this.customerId = null;
        this.firstName = null;
        this.lastName = null;
        this.address = null;
        this.city = null;
        this.email = null;
        this.phone = null;
        this.state = null;
        this.zip = null;
		this.modifiedBy = null;
		this.quoteRevisionNumber = null;
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./src/app/model/customer.ts